// import ReactDOM from "react-dom";
import React from "react";
import { BrowserRouter,Routes, Route } from "react-router-dom";
import * as ReactDOMClient from 'react-dom/client';
import './index.css';
import App from "./App";
import PrivacyPolicy from "./components/PrivacyPolicy";


//  const rootElement = document.getElementById('root');
// const root = createRoot(document.getElementById('root'));


const rootElement = document.getElementById("root");

const root = ReactDOMClient.createRoot(rootElement);

root.render(
  // </React.StrictMode>
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
          {/* <App /> */}
    </BrowserRouter>
  // </React.StrictMode>
  );



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
